import React from 'react';
import { Props as BaseSiteHeaderProps } from '../SiteHeader';
import Logo from '@wix/da-ds/pkg/Logo';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import Burger from '../_partials/Burger';
import SearchIconButton from './_partials/SearchIconButton';
import SubmitButton from './_partials/SubmitDropdown';
import UserMenuButton from './_partials/UserMenuButton';
import NotificationsDropdownWrapper from '../_partials/NotificationsDropdownWrapper';
import DamzDropdownWrapper from '../_partials/DamzDropdownWrapper';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import LanguageSelector from '../../LanguageSelector/LanguageSelector';

import s from './SiteHeaderMobile.scss';

export interface Props extends BaseSiteHeaderProps {
  isLoggedIn?: boolean;
  isUserDropdownOpen: boolean;
  closeNotificationsDropdown: () => void;
}

const SiteHeaderMobile: React.FC<Props> = ({
  showNetworkBar,
  isLoggedIn,
  isUserDropdownOpen,
  closeNotificationsDropdown,
}) => {
  const { t } = useTranslation();
  const isLocalize = useFlag('localize');

  return (
    <div className={s['root']}>
      <div className={s['left-zone']}>
        <Burger showNetworkBar={showNetworkBar} iconClassName={s['icon']} />
        <BiLink
          biData={BiData<TopNavClickBiEvent>({
            evid: 700,
            link_url: Url.buildFromPath(URLS.ROOT),
            link_name: 'logo',
          })}
          href={Url.buildFromPath(URLS.ROOT)}
          aria-label={t('siteHeader.a11y.home')}
          className={s['logo-link']}
        >
          <Logo size="tiny" withText={false} />
        </BiLink>
        {isLoggedIn && (
          <>
            <NotificationsDropdownWrapper
              iconClassName={s['icon']}
              numberClassName={s['number']}
            />

            <DamzDropdownWrapper
              iconClassName={s['icon']}
              numberClassName={s['number']}
            />
          </>
        )}
      </div>
      <div className={s['right-zone']}>
        <SearchIconButton className={s['icon']} />
        {isLocalize && !isLoggedIn && (
          <LanguageSelector className={s['icon']} />
        )}
        <UserMenuButton hideNotificationCount={true} />
        <SubmitButton
          className={s['submit-button']}
          menuClassName={s['submit-menu']}
        />
      </div>
    </div>
  );
};
SiteHeaderMobile.displayName = 'SiteHeaderMobile';

export default SiteHeaderMobile;
